// Hernando Beach (Luxury Home) imports
import Hernando_Main from "../../assets/images/property/pmgluxury/Hernando_Beach_single_story_home_for_rent.jpg";
import Hernando_Waterfront_FL from "../../assets/images/property/pmgluxury/Waterfront_Home_Rental_Florida.jpg";
import Hernando_Waterfront_SH from "../../assets/images/property/pmgluxury/Waterfront_Home_Rental_Spring_Hill.jpg";
import Hernando_Waterfront_Tampa from "../../assets/images/property/pmgluxury/Waterfront_Home_Rental_Tampa.jpg";
import Hernando_Bedroom2 from "../../assets/images/property/pmgluxury/2_Bedroom_2Bathroom_Snowbird.jpg";
import Hernando_Bath2 from "../../assets/images/property/pmgluxury/2nd_Bathroom_Herndno_Seasonal_Rental.jpg";
import Hernando_Dining from "../../assets/images/property/pmgluxury/Dining_Room_Area_Waterfront_Snowbird_Florida_Seasonal.jpg";
import Hernando_Pool from "../../assets/images/property/pmgluxury/Direct_Gulf_Access_Pool.jpg";
import Hernando_BoatLift from "../../assets/images/property/pmgluxury/Hernando_Beach_Boat_Lift_Rental.jpg";
import Hernando_Sauna from "../../assets/images/property/pmgluxury/Hernando_Beach_Rental_Suana.jpg";
import Hernando_Waterfront_Rental from "../../assets/images/property/pmgluxury/Hernando_Beach_Wtaerfront_Rentals.jpg";
import Hernando_Living from "../../assets/images/property/pmgluxury/Livingroom_With_King_Trundle_Bed.jpg";
import Hernando_MasterBath from "../../assets/images/property/pmgluxury/Master_Bathroom_Waterfall_Shower_Hernando_Beach.jpg";
import Hernando_MasterBed from "../../assets/images/property/pmgluxury/Master_Bedroom_Hernando_Beach_Winter_Rental.jpg";
import Hernando_SaltPool from "../../assets/images/property/pmgluxury/Salt_Water_Pool_Hottub.jpg";

// Islamorada Liveaboard Slip imports
import Islamorada_Sunset from "../../assets/images/property/pmgluxury/Boat_Slip_Sunset_Islamorada.jpg";
import Islamorada_Slip from "../../assets/images/property/pmgluxury/Florida_Keys_Boat_Slip_Liveabaoad.jpg";
import Islamorada_Marina from "../../assets/images/property/pmgluxury/Florida_Keys_Marina_Liveabaord_Boat_Slips_For_Rent.jpeg";
import Islamorada_BarSunset from "../../assets/images/property/pmgluxury/Isamorada_Boating_Bar_sunset.jpg";
import Islamorada_Lorelei from "../../assets/images/property/pmgluxury/Islamorada-Yacht-Basin-Lorelei-Restaurant.jpg";
import Islamorada_Tiki from "../../assets/images/property/pmgluxury/Islamorada_Tiki_Bar_Marina.jpg";
import Islamorada_LoreleiSunset from "../../assets/images/property/pmgluxury/Lorelei_SUnset_Bar.jpg";
import Islamorada_Dinghy from "../../assets/images/property/pmgluxury/dingy_yacht_tender_allowed.jpg";

import client1 from "../../assets/images/client/01.webp";
import client2 from "../../assets/images/client/02.webp";
import client3 from "../../assets/images/client/03.webp";
import client4 from "../../assets/images/client/04.webp";
import client5 from "../../assets/images/client/05.webp";
import client6 from "../../assets/images/client/06.webp";
import client7 from "../../assets/images/client/07.webp";
import client8 from "../../assets/images/client/08.webp";

import cate1 from "../../assets/images/property/residential.webp";
import cate2 from "../../assets/images/property/land.webp";

import about1 from "../../assets/images/rent.webp";
import about2 from "../../assets/images/buy.webp";
import about3 from "../../assets/images/sell.webp";

import agency1 from "../../assets/images/agency/1.webp";
import agency2 from "../../assets/images/agency/2.webp";
import agency3 from "../../assets/images/agency/3.webp";
import agency4 from "../../assets/images/agency/4.webp";
import agency5 from "../../assets/images/agency/5.webp";
import agency6 from "../../assets/images/agency/6.webp";
import agency7 from "../../assets/images/agency/7.webp";
import agency8 from "../../assets/images/agency/8.webp";
import agency9 from "../../assets/images/agency/9.webp";

export const properties = [
  {
    id: 1,
    image: Hernando_Main,
    name: "Flamingo Blvd, Hernando Beach, FL — Luxury Home w/ Salt Water Pool, Hot Tub, Sauna & Boat Lift",
    category: "house",
    price: "Call to Ask",
    priority: 10,
    address: "Hernando Beach, Florida",
    mapSrc:
      "https://maps.google.com/maps?q=28.4778,-82.6612(Hernando+Beach)&z=10&output=embed",
    description: `WATERFRONT VIEW W/DOCK AND BOAT LIFT — HERNANDO BEACH. Luxury furnished 2BR/2BA with salt water pool/hot tub, sauna, brand new appliances/AC, and much more. All Utilities Included.

Snowbird Monthly Rate Oct–April: Call to Ask (First month's rent & security deposit required).
Vaca / Fish Trip / Family / Corporate / Traveling Nurses Monthly Rate May–Sept: Call to Ask.

Fully Furnished! Turnkey. All Utilities, Landscaping, Trash Removal Services, Internet — Everything Included! Discounts available for 6-month Snowbird rentals.

BEST VIEW IN HERNANDO BEACH! Experience true tropical paradise with a boat lift and dock with direct Gulf of Mexico access in this beautifully updated single-story, 2-bedroom, 2-bath waterfront home. Perfectly located just five houses from open water and the "flats" sandbar on the main canal, and tucked inside a canal community hidden behind an 11,000-acre nature preserve — you'll enjoy peaceful surroundings, abundant wildlife, and some of Florida's best fishing and scalloping right outside your door.

Step inside to find a modern kitchen with granite countertops, brand-new appliances, new garbage disposal, and decorative backsplash. The open living space features wood plank tile flooring throughout, high-end furnishings, an 86" TV with sound system/subwoofer, a cozy gas fireplace with newly replaced internal components, and updated plumbing, ductwork, and AC.

Outdoor living at its finest: a private screened-in heated salt water pool and hot tub, large lanai with bar and TV, plumbed cold plunge, full sauna, and multiple docks — including a covered boat lift, stationary dock, and jet ski dock — all with direct Gulf access. Perfect for boating, fishing, kayaking, and sunset cruising. Bring your boat. Bring your jet ski. One-of-a-kind location.

Extra Features:
• Dual convection Bluetooth oven
• Water softener for pure water
• No HOA or covenants — bring your boat trailer and golf cart
• Ice machine on property
• Located near local waterfront restaurants, shops, and major amenities, yet tucked away from the hustle and bustle

Rental Details:
• Available: Monthly rentals May–September | Seasonal (Oct/Nov–Spring) for Snowbirds. Discounts for 6-month Snowbird rental!
• Fully furnished | All utilities & high-speed internet included
• First month's rent and security deposit required
• Bring your boat, jet skis, and water toys!

Pet-Free Home / Smoke-Free Home.

About Hernando Beach — A Scenic, Waterfront Gem
Hernando Beach is a tranquil, canal-centered community perched on Florida's Gulf Coast, approximately an hour northwest of Tampa. Despite its "beach" name, it's best described as a network of waterfront neighborhoods built around canals. Situated behind an 11,000-acre nature preserve, Hernando Beach is a hidden gem with mesmerizing sunsets, direct gulf access, beach-vibe restaurants and bars, and a fishing and boating paradise.`,
    features: {
      bedrooms: 2,
      bathrooms: 2,
      sqft: 1201,
      pool: true,
      waterfront: true,
      garage: 0,
    },
    detail: [
      Hernando_Main,
      Hernando_Waterfront_Rental,
      Hernando_Waterfront_FL,
      Hernando_Waterfront_SH,
      Hernando_Waterfront_Tampa,
      Hernando_SaltPool,
      Hernando_Pool,
      Hernando_BoatLift,
      Hernando_Sauna,
      Hernando_Living,
      Hernando_Dining,
      Hernando_MasterBed,
      Hernando_MasterBath,
      Hernando_Bedroom2,
      Hernando_Bath2,
    ],
  },
  {
    id: 2,
    image: Islamorada_Sunset,
    name: "Rare Islamorada Liveaboard Slip at Lorelei Cabana Bar — 45'x20'",
    category: "boat-parking",
    price: "Call to Ask",
    priority: 9,
    address: "Islamorada, FL",
    mapSrc:
      "https://maps.google.com/maps?q=24.9243,-80.6276(Islamorada)&z=10&output=embed",
    description: `Rare grandfathered liveaboard slip in Islamorada at the Lorelei Cabana Bar. 45' x 20'.

Must carry 1–2MM insurance depending on boat and abide by other HOA and Lorelei rules.

This is the coolest place with the coolest people and dock to have your boat. You would need to spend an evening at our "docktail hour" — our neighbors here are an amazing little community. We eat and drink and go out on the water together, and look after each others' vessels when folks are out of town.

Rent is pretty fixed because of the high cost of ownership, mortgage, HOA fees, utilities, etc. The plus is we include all of this — so you just pull in and enjoy.

Includes:
• Parking spot at Lorelei Cabana Bar
• Access to showers and bathrooms
• Optional fee-based pumpouts
• Ability to have one dinghy in your slip

The slip is conveniently at the back of the coolest 250-person sunset cabana bar — probably our personal favorite place in the world.

Thanks for looking.`,
    features: {
      slipLength: 45,
      covered: false,
      powerHookup: true,
      waterAccess: true,
      security: true,
    },
    detail: [
      Islamorada_Sunset,
      Islamorada_Slip,
      Islamorada_Marina,
      Islamorada_Lorelei,
      Islamorada_LoreleiSunset,
      Islamorada_BarSunset,
      Islamorada_Tiki,
      Islamorada_Dinghy,
    ],
  },
];

export const review = [
  {
    id: "1",
    profile: client1,
    name: "Calvin Carlo",
    designation: "Manager",
    description:
      "Hously made the processes so easy. Hously instantly increased the amount of interest and ultimately saved us over $10,000.",
  },
  {
    id: "2",
    profile: client2,
    name: "Christa Smith",
    designation: "Manager",
    description:
      'I highly recommend Hously as the new way to sell your home "by owner". My home sold in 24 hours for the asking price. Best $400 you could spend to sell your home.',
  },
  {
    id: "3",
    profile: client3,
    name: "Christa Smith",
    designation: "Manager",
    description:
      "My favorite part about selling my home myself was that we got to meet and get to know the people personally. This made it so much more enjoyable!",
  },
  {
    id: "4",
    profile: client4,
    name: "Christa Smith",
    designation: "Manager",
    description: "Great experience all around! Easy to use and efficient.",
  },
];
export const teamdata = [
  {
    image: client4,
    name: "Michael Chen",
    title: "Property Director",
  },
  {
    image: client5,
    name: "Sarah Rodriguez",
    title: "Marina Operations Manager",
  },
  {
    image: client6,
    name: "David Thompson",
    title: "Rental Coordinator",
  },
  {
    image: client7,
    name: "Lisa Anderson",
    title: "Client Relations Manager",
  },
];

export const categoriesData = [
  {
    image: cate1,
    name: "Luxury Houses",
    title: "Available Now",
  },
  {
    image: cate2,
    name: "Boat Slips",
    title: "Available Now",
  },
];

export const blogList = [
  {
    id: 1,
    title: "Skills That You Can Learn In The Real Estate Market",
    date: "13th March, 2023",
    type: "Industrial",
    image: Hernando_Main,
  },
  {
    id: 2,
    title: "Learn The Truth About Real Estate Industry",
    date: "5th May, 2023",
    type: "Industrial",
    image: Islamorada_Sunset,
  },
  {
    id: 3,
    title: "10 Quick Tips About Business Development",
    date: "19th June, 2023",
    type: "Industrial",
    image: Hernando_Waterfront_Rental,
  },
  {
    id: 4,
    title: "14 Common Misconceptions About Business Development",
    date: "20th June, 2023",
    type: "Industrial",
    image: Islamorada_Lorelei,
  },
  {
    id: 5,
    title: "10 Things Your Competitors Can Teach You About Real Estate",
    date: "31st Aug, 2023",
    type: "Industrial",
    image: Hernando_SaltPool,
  },
  {
    id: 6,
    title: "Why We Love Real Estate",
    date: "1st Sep, 2023",
    type: "Industrial",
    image: Islamorada_Tiki,
  },
];

export const aboutData = [
  {
    image: about1,
    title: "Luxury Homes",
    desc: "Premium fully-furnished waterfront homes with direct Gulf access, salt water pools, boat lifts, and full-service property management.",
  },
  {
    image: about2,
    title: "Liveaboard Boat Slips",
    desc: "Rare grandfathered liveaboard slips in Islamorada at iconic Lorelei Cabana Bar — utilities, dockage, and amenities included.",
  },
  {
    image: about3,
    title: "Premium Service",
    desc: "Dedicated concierge support, maintenance coordination, and personalized rental assistance for a turnkey Florida experience.",
  },
];

export const agentData = [
  {
    id: 1,
    image: client4,
    name: "Jack John",
    position: "Property Broker",
  },
  {
    id: 2,
    image: client5,
    name: "Krista John",
    position: "Property Broker",
  },
  {
    id: 3,
    image: client6,
    name: "Roger Jackson",
    position: "Property Broker",
  },
  {
    id: 4,
    image: client7,
    name: "Johnny English",
    position: "Property Broker",
  },
  {
    id: 5,
    image: client8,
    name: "Clayton Dalke",
    position: "Property Broker",
  },
  {
    id: 6,
    image: client1,
    name: "Christopher Myers",
    position: "Property Broker",
  },
  {
    id: 7,
    image: client2,
    name: "Mary Petersen",
    position: "Property Broker",
  },
  {
    id: 8,
    image: client3,
    name: "Amber Durden",
    position: "Property Broker",
  },
];

export const agencyData = [
  {
    id: 1,
    image: agency1,
    name: "Realty Zen",
    title: "Real Estate Agency",
  },
  {
    id: 2,
    image: agency2,
    name: "Realty Zen",
    title: "Real Estate Agency",
  },
  {
    id: 3,
    image: agency3,
    name: "Realty Zen",
    title: "Real Estate Agency",
  },
  {
    id: 4,
    image: agency4,
    name: "Realty Zen",
    title: "Real Estate Agency",
  },
  {
    id: 5,
    image: agency5,
    name: "Realty Zen",
    title: "Real Estate Agency",
  },
  {
    id: 6,
    image: agency6,
    name: "Realty Zen",
    title: "Real Estate Agency",
  },
  {
    id: 7,
    image: agency7,
    name: "Realty Zen",
    title: "Real Estate Agency",
  },
  {
    id: 8,
    image: agency8,
    name: "Realty Zen",
    title: "Real Estate Agency",
  },
  {
    id: 9,
    image: agency9,
    name: "Realty Zen",
    title: "Real Estate Agency",
  },
];
